module.exports = __webpack_public_path__ + "img/der_01_question-mark.3c6105c9.png";